import { TextField } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles({
  root: {
    flexGrow: 1,
  },
  mt: {
    marginTop: '10px',
  },
  appBar: {
    color: '#0A688D',
    backgroundColor: 'rgba(255, 255, 255, 1)',
    boxShadow: '0 0 0 0 #fff',
    borderBottom: '1px solid #ccc',
  },
  indicator: {
    backgroundColor: 'white',
    borderTop: '1px solid #333',
  },
  titleBar: {
    flex: 1,
    flexDirection: 'row',
    alignContent: 'space-between',
  },
  btn: {
    backgroundColor: '#0A688D',
    color: '#fff !important',
    padding: '6px 32px !important',
    marginRight: '2ch',
    borderTop: '1px solid #ccc',
    background: '#fff',
    zIndex: '999',
    '&:hover': {
      outline: '0px !important',
      backgroundColor: '#0A688D',
      color: '#fff',
      // boxShadow: '0 0 0 0.2rem #333',
    },
    '&:focus': {
      outline: '0px !important',
      backgroundColor: '#0A688D',
      color: '#fff',
      // boxShadow: '0 0 0 0.2rem #333',
    },
  },
  customDatepicker: {
    width: '100%',
    '& > div': {
      width: '100%',
    },
  },
  addProcedureCodeBtn: {
    backgroundColor: '#0A688D',
    color: '#fff !important',
    padding: '6px 32px !important',
    float: 'right',
    borderTop: '1px solid #ccc',
    background: '#fff',
    width: '265px',
    marginTop: '-65px',
    zIndex: '999',
    '&:hover': {
      outline: '0px !important',
      backgroundColor: '#0A688D',
      color: '#fff',
      // boxShadow: '0 0 0 0.2rem #333',
    },
    '&:focus': {
      outline: '0px !important',
      backgroundColor: '#0A688D',
      color: '#fff',
      // boxShadow: '0 0 0 0.2rem #333',
    },
  },
  disableBtn: {
    backgroundColor: '#797979',
    color: '#fff !important',
    padding: '6px 32px !important',
    marginRight: '2ch',
    borderTop: '1px solid #ccc',
    disabled: true,
    pointerEvents: 'none',
    cursor: 'default',
    zIndex: '999',
    '&:hover': {
      backgroundColor: '#797979',
    },
  },
  buttonGrey: {
    backgroundColor: '#797979',

    '&:hover': {
      backgroundColor: '#797979',
    },
  },
  mp: {
    margin: 0,
    padding: 0,
  },
  modalContainer: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 720,
    background: '#fff',
    border: '2px solid #ccc',
    padding: 20,
    height: '70%',
    overflow: 'hidden',
  },
  table: {
    minWidth: 600,
    background: '#f2f2f2',
  },
  history: {
    marginTop: 10,
  },
  hr: {
    marginTop: 0,
    borderBottom: 1,
  },
  icon: {
    // color: '#0A688D'
  },
  errorIcon: {
    color: '#f00',
  },
  actionView: {
    flex: 1,
    flexDirection: 'row',
    width: '100px',
    textAlign: 'center',
  },
  anchor: {
    textDecoration: 'none',
    color: '#0A688D',
  },
  alignRight: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'flex-end',
  },
  TextField: {
    textAlign: 'center',
    '& label.Mui-focused': {
      color: '#0A688D',
    },
  },
  TextBox: {
    width: '50ch',
    margin: '1rem',
  },
  HolidayDate: {
    width: '50ch',
    margin: '1rem',
  },
  TextBoxDescription: {
    width: '50ch',
    margin: '1rem',
  },
  mb: {
    marginBottom: '10px',
  },
  container: {
    flex: 1,
    display: 'block',
  },
  buttonMargin: {
    marginLeft: '10px',
  },
  dialogHeight: {
    overflowY: 'visible',
  },
  discardDialogHeight: {
    height: '180px',
  },
  discardDialogContent: {
    display: 'flex',
    justifyContent: 'left',
    marginTop: '20px',
  },
  buttonActions: {
    width: '100%',
    bottom: '0',
    left: '0',
    borderTop: '1px solid #ccc',
    background: '#fff',
    zIndex: '999',
  },
  searchTable: {
    height: '473px',
    overflowX: 'hidden',
    overflowY: 'auto',
  },
  dialogTitle: {
    backgroundColor: '#0A688D',
    color: '#FFF',
  },
  error: {
    color: 'red',
    marginLeft: '55px',
  },
})
